import { toast } from "react-toastify";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { accountServices } from "../../services";
import { showNotificationWithTimeout } from "../actions/toastActions";
import * as actionTypes from "../actionTypes";

let errMsg = "Something went wrong!";

function* getSeceruityQues(action) {
  const res = yield call(accountServices.getSeceruityQue, action?.query);
  console.log("GET_SECERUITY_QUE_SUCCEEDED", res);
  if (res) {
    if (res?.status) {
      console.log("GET_SECERUITY_QUE_SUCCEEDED", res?.data);
      yield put({
        type: actionTypes.GET_SECERUITY_QUE_SUCCEEDED,
        payload: {
          security_questions: res?.data,
        },
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveProfileDetails(action) {
  const res = yield call(accountServices.saveProfileDetails, action.payload);
  if (res) {
    if (res?.status && res?.data) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      yield put({
        type: actionTypes.SAVE_LOGIN_DETAILS_SUCCEEDED,
        payload: {
          user_details: res?.data,
        },
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      // toast.error(res?.message ?? errMsg);
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
    // toast.error(errMsg);
  }
}

function* changePasswordDetails(action) {
  const res = yield call(accountServices.changePasswordDetails, action.payload);
  if (res) {
    if (res?.status && res?.data) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      // toast.error(res?.message ?? errMsg);
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
    // toast.error(errMsg);
  }
}

function* accountSaga() {
  yield takeLatest(actionTypes.GET_SECERUITY_QUE, getSeceruityQues);
  yield takeLatest(actionTypes.SAVE_PROFILE_DETAILS, saveProfileDetails);
  yield takeLatest(actionTypes.CHANGE_PASSWORD_DETAILS, changePasswordDetails);
}

export default accountSaga;
